/**
 * DB 제약 이름 → 사람이 읽는 문장. 서버는 400 + 제약 이름을 준다(`common/db-error.filter.ts`).
 * 여기 없는 제약은 서버 문장 그대로 쓴다.
 */
export const CONSTRAINT_TEXT: Record<string, string> = {
  investment_companies_biz_no_uq: '같은 사업자번호의 투자처가 이미 있습니다',
  investment_sectors_name_uq: '같은 이름의 섹터가 이미 있습니다',
  investment_report_items_name_uq: '같은 이름의 항목이 이미 있습니다',
  investment_financials_uq: '그 연도 · 기간 재무가 이미 있습니다 — 있는 줄을 고치세요',
  investment_report_rounds_uq: '그 연도 · 구분 회차가 이미 있습니다',
  investment_risk_rounds_code_uq: '그 분기 회차가 이미 있습니다',
  investment_closing_tasks_uq: '이미 체크한 할 일입니다',
  investment_vics_submissions_uq: '그 기간 VICS 보고가 이미 있습니다',
  investment_vehicles_fee_prepaid_ck: '선취 연수는 1~10 입니다',
  investment_deals_acquisition_ck: '인수 방식은 신주 또는 구주입니다',
  investment_cashflows_amount_ck: '금액은 0보다 커야 합니다',
  investment_cashflows_fee_ck: '보수는 관리보수 · 성과보수 중 하나를 고르세요',
  investment_cashflows_part_ck: '출자 · 분배는 참여자를 고르세요',
  investment_cashflows_deal_ck: '투자 · 회수 · 배당은 투자 건을 고르세요',
  investment_participants_commit_ck: '약정액은 0 이상이어야 합니다',
  investment_participants_ratio_ck: '분배 비율은 0~1 사이여야 합니다',
  investment_companies_fm_ck: '결산월은 1~12 입니다',
  investment_vehicles_fye_ck: '회계연도 말은 12-31 처럼 적습니다',
};
